module.exports = __webpack_public_path__ + "img/logo-2-en.14029b0c.png";